import * as Yup from "yup";

export const schemaSingUp = Yup.object().shape({
  name: Yup.string().required("campo Obrigatório"),
  phone: Yup.string().required("campo Obrigatório"),
  ddi: Yup.string().required("campo Obrigatório"),
  email: Yup.string().required("campo Obrigatório"),
  investment_amount: Yup.string().required("campo Obrigatório"),
});
